import Button from "../../Button";
import Webcam from "react-webcam";
import React, { useContext, useEffect, useState } from "react";
import constants from "../../../constants";
import { Editor } from "@tinymce/tinymce-react";
import ReviewSvgIcon from "../../../Svg/ReviewSvgIcon";
import InstructionPageBody from "./InstructionPageBody";
import AlertContext from "../../../context/AlertContext";
import RightArrowSvgIcon from "../../../Svg/RightArrowSvgIcon";
import useCommonFunctionHooks from "../../../Hooks/useCommonFunctionHooks";
import InstructionHooks from "../../../Hooks/InstructionPage/InstructionHooks";
import InstructionPageHooks from "../../../Hooks/InstructionPage/InstructionPageHooks";

export default function Instruction() {
  const Alert = useContext(AlertContext);
  const InstructionPageHks = InstructionPageHooks();
  const InstructionHks = InstructionHooks();
  const [permissionChecked, setPermissionChecked] = useState(false);

  const { handleWebCamError, picRef } = useCommonFunctionHooks();
  const isPreview = new URLSearchParams(window.location.search).get("mode") === "preview";
  const shouldRequireCameraMic =
    Alert.testData?.testmode === constants.MODE.TEST_MODE &&
    Alert.testData.proctored !== constants.PROCTORING_MODE.TAB &&
    Alert.testData.proctored !== constants.PROCTORING_MODE.NONE &&
    !isPreview;

  const shouldRequireLocation =
    Alert.testData?.testmode === constants.MODE.TEST_MODE &&
    Alert.testData.proctored === constants.PROCTORING_MODE.TAB_CAM_LOC &&
    !isPreview;
  const requestLocation = () =>
    new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject(new Error("Location not supported"));
        return;
      }

      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const latitude = position.coords.latitude;
          const longitude = position.coords.longitude;
          const addressUrl = `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`;
          const response = await fetch(addressUrl);
          const addressData = await response.json();
          const locationAddress = [
            addressData.address.suburb,
            addressData.address.city,
            addressData.address.state
          ]
            .filter(Boolean) // Removes undefined, null, or empty values
            .join(",");
          console.log(locationAddress);
          resolve({
            latitude,
            longitude,
            address: locationAddress,
          });
        },
        (error) => reject(error),
        {
          enableHighAccuracy: true,
          timeout: 15000,
          maximumAge: 0,
        }
      );
      // const address=`https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`;
      // console.log("Address:", address);
    });
  // useEffect(() => {
  //   if (shouldRequireCameraMic) {
  //     Promise.all([
  //       navigator.mediaDevices.getUserMedia({ video: true }).catch((error) => {
  //         throw new Error("Video failed");
  //       }),
  //       navigator.mediaDevices.getUserMedia({ audio: true }).catch((error) => {
  //         throw new Error("Audio failed");
  //       }),
  //     ])
  //       .then(([vidStream, audioStream]) => {
  //         Alert.streamRef.current = vidStream;
  //         audioStream.getTracks().forEach((track) => {
  //           Alert.streamRef.current.addTrack(track);
  //         });
  //         Alert.setCamAvailable(true);
  //         InstructionPageHks.setAudioAvailable(true);
  //         setPermissionChecked(true);
  //       })
  //       .catch((err) => {
  //         console.error("Error:", err);
  //         if (
  //           err.message === "Video failed" &&
  //           err.message === "Audio failed"
  //         ) {
  //           InstructionPageHks.setAudioAvailable(false);
  //           Alert.setCamAvailable(false);
  //         }
  //         if (err.message === "Video failed") {
  //           Alert.setCamAvailable(false);
  //           InstructionPageHks.setAudioAvailable(true);
  //         }
  //         if (err.message === "Audio failed") {
  //           InstructionPageHks.setAudioAvailable(false);
  //           Alert.setCamAvailable(true);
  //         }
  //         setPermissionChecked(true);
  //       });
  //   } else if (
  //     Alert.testData.proctored === constants.PROCTORING_MODE.NONE ||
  //     Alert.testData.proctored === constants.PROCTORING_MODE.TAB
  //   ) {
  //     setPermissionChecked(true);
  //   }
  //   if (shouldRequireLocation) {
  //     requestLocation()
  //       .then((location) => {
  //         console.log("Location obtained:", location);
  //         Alert.setLocationAvailable(true);
  //         Alert.setProctorLocation(location);
  //         Alert.setLocationError(null);
  //       })
  //       .catch((error) => {
  //         console.error("Error obtaining location:", error);
  //         Alert.setLocationAvailable(false);
  //         Alert.setProctorLocation(null);
  //         Alert.setLocationError(error);
  //       });
  //   }
  //   if (
  //     Alert.testData.videoqn &&
  //     Alert.testData.testmode === constants.MODE.PRACTICE_MODE
  //   ) {
  //     Alert.setCamAvailable(true);
  //     InstructionPageHks.setAudioAvailable(false);
  //   }
  //   return () => InstructionPageHks.removeAccess();
  // }, []);
  useEffect(() => {
    const checkPermissions = async () => {
      try {
        if (shouldRequireCameraMic) {
          const [vidStream, audioStream] = await Promise.all([
            navigator.mediaDevices.getUserMedia({ video: true }).catch(() => {
              throw new Error("Video failed");
            }),
            navigator.mediaDevices.getUserMedia({ audio: true }).catch(() => {
              throw new Error("Audio failed");
            }),
          ]);

          Alert.streamRef.current = vidStream;
          audioStream.getTracks().forEach((track) => {
            Alert.streamRef.current.addTrack(track);
          });

          Alert.setCamAvailable(true);
          InstructionPageHks.setAudioAvailable(true);
        } else if (
          Alert.testData.proctored === constants.PROCTORING_MODE.NONE ||
          Alert.testData.proctored === constants.PROCTORING_MODE.TAB
        ) {
          setPermissionChecked(true);
        }

        if (shouldRequireLocation) {
          const location = await requestLocation();

          console.log("Location obtained:", location);
          Alert.setLocationAvailable(true);
          Alert.setProctorLocation(location);
          Alert.setLocationError(null);
        }

        setPermissionChecked(true);
      } catch (err) {
        console.error("Error:", err);

        if (err.message === "Video failed") {
          Alert.setCamAvailable(false);
          InstructionPageHks.setAudioAvailable(true);
        }

        if (err.message === "Audio failed") {
          InstructionPageHks.setAudioAvailable(false);
          Alert.setCamAvailable(true);
        }

        if (
          err.message !== "Video failed" &&
          err.message !== "Audio failed"
        ) {
          Alert.setLocationAvailable(false);
          Alert.setProctorLocation(null);
          Alert.setLocationError(err);
        }

        setPermissionChecked(true);
      }
    };

    checkPermissions();

    return () => InstructionPageHks.removeAccess();
  }, []);
  return (
    <div className="instructionMainContainer">
      <p className="instructionHeader">
        Please read the instructions carefully before starting the{" "}
        {InstructionHks.getTestType(Alert.testData)} test:
      </p>
      {Alert.testData.single ||
        Alert.testData.videoqn ||
        Alert.testData.ainterview ||
        Alert.testData.testtype === constants.libTypeIds.SQL ||
        Alert.testData.proctored === constants.PROCTORING_MODE.NONE ||
        Alert.testData.testtype === constants.libTypeIds.CODING_CHALLENGE ? (
        <InstructionPageBody />
      ) : (
        <div className="instructionWebCamDiv">
          <ul className="instructionBodyList">
            {Alert.testData.proctored !== constants.PROCTORING_MODE.NONE && (
              <>
                <li>
                  The countdown timer in the top right displays the remaining
                  time available.
                </li>
                <li>
                  When the countdown timer reaches zero, the test will be
                  auto-submitted.
                </li>

                <li className="instructionBodyListInnerText">
                  {(Alert.testData.testtype === constants.libTypeIds.DESCRIPTIVE || Alert.testData.testtype === constants.libTypeIds.CODING_SNIPPET) &&
                    Alert.testData.videoqn !== 1
                    ? `If you switch tabs from this window, the assignment will be auto
                      submitted. Every time you do this, your marks against this
                      challenge will be reduced.`
                    : `The question selector on the right side of the screen will show the status of each question using these specific status:`}
                </li>

                <ul className="instructionBodyListUnordered">
                  <li className="instructionBodyUnorderedList">
                    <div className="instructionBodyUnorderedListNotViewLegend"></div>
                    <span className="instructionBodyUnorderedListLegendText">
                      You are yet to view this question.
                    </span>
                  </li>
                  <li className="instructionBodyUnorderedList">
                    <div className="instructionBodyUnorderedListViewLegend"></div>
                    <span className="instructionBodyUnorderedListLegendText">
                      You viewed the question, but did not answer.
                    </span>
                  </li>
                  <li className="instructionBodyUnorderedList">
                    <div className="instructionBodyUnorderedListReviewLegend"></div>
                    <span className="instructionBodyUnorderedListLegendText">
                      You have marked the question for review.
                    </span>
                  </li>
                  <li className="instructionBodyUnorderedList">
                    <div className="instructionBodyUnorderedListAnsweredLegend"></div>
                    <span className="instructionBodyUnorderedListLegendAnsweredText">
                      You have answered the question.
                    </span>
                  </li>
                </ul>
              </>
            )}
          </ul>
          {Alert.testData.testmode === constants.MODE.TEST_MODE &&
            (Alert.testData.proctored === constants.PROCTORING_MODE.TAB_CAM ||
              Alert.testData.proctored === constants.PROCTORING_MODE.TAB_CAM_LOC) && (
              <Webcam
                className="instructionWebCam"
                screenshotFormat="image/jpeg"
                ref={picRef}
                onUserMediaError={handleWebCamError}
                videoConstraints={InstructionPageHks.videoConstraints}
              />
            )}
        </div>
      )}
      {!Alert.testData.single &&
        !Alert.testData.mockuse &&
        !Alert.testData.ainterview &&
        Alert.testData.videoqn !== 1 &&
        Alert.testData.testtype !== constants.libTypeIds.CODING_CHALLENGE &&
        Alert.testData.testtype !== constants.libTypeIds.SQL &&
        Alert.testData.proctored !== constants.PROCTORING_MODE.NONE && (
          <ul className="instructionBodyList">
            <li className="instructionBodyListInnerText">
              You can bookmark a question to review later, by clicking on the
              icon next to the question:
            </li>
            <ul className="instructionBodyListUnordered">
              <li className="instructionBodyUnorderedList">
                <ReviewSvgIcon />
                <span className="instructionBodyUnorderedListLegendText">
                  Question not marked for review
                </span>
              </li>
              <li className="instructionBodyUnorderedList">
                <ReviewSvgIcon mark={"mark"} />
                <span className="instructionBodyUnorderedListLegendText">
                  Question marked for review
                </span>
              </li>
            </ul>
          </ul>
        )}
      {Alert.testData.instruction !== "" &&
        Alert.testData.instruction !== null &&
        Alert.testData.testtype !== constants.libTypeIds.SQL && ( //removed sql from additional instructions
          <div className="additionalInstructionDiv">
            <p className="instructionSubHeader">Additional instructions:</p>
            <Editor
              disabled={true}
              toolbar={false}
              menubar={false}
              branding={false}
              statusbar={false}
              value={Alert.testData.instruction}
              tinymceScriptSrc="/tinymce/tinymce.min.js"
              init={{
                resize: false,
                readonly: true,
                menubar: false,
                statusbar: false,
                license_key: "gpl",
                selector: "textarea",
                plugins: "autoresize",
              }}
            />
          </div>
        )}
      <div className="instructionFooter">
        <Button
          size="lg"
          disable={!permissionChecked || Alert.buttonDisable || isPreview}
          onClick={InstructionPageHks.handleCheck}
          icon={{ type: "trailing", icon: <RightArrowSvgIcon /> }}
          hierarchy={{
            type: "primary",
            buttonText: InstructionPageHks.getButtonText(),
          }}
        />
      </div>
    </div>
  );
}

